<template>
  <svg :width="width" :height="height" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 18.7V13.7H8.20775V18.7H6.5ZM11.204 18.7V10.1H12.9115V18.7H11.204ZM15.7922 18.7V5.30005H17.5V18.7H15.7922Z" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'Analytics',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 24
    },
    height: {
      type: [Number, String],
      required: false,
      default: 24
    },
    color: {
      type: String,
      required: false,
      default: '#62646A'
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.width} ${this.height}`;
    }
  }
}
</script>
